// src/marketing/editorial/Prose.tsx
import { JSX } from 'react'
import { renderMarkdown } from '../docs/markdown'

export function Prose({ md }: { md: string }): JSX.Element {
  return (
    <div
      className="prose"
      dangerouslySetInnerHTML={{ __html: renderMarkdown(md) }}
    />
  )
}
